/*tslint:disable:no-bitwise*/

import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

const symbols = {
  'RUR': '₽',
  'EUR': '€',
  'KZT': '₸',
  'UAH': '₴',
  'USD': '$',
  'PLN': 'zł'
};

@Pipe({
  name: 'currencyFormat'
})
export class CurrencyFormatPipe implements PipeTransform {

  constructor(
    private sanitizer: DomSanitizer
  ) {}

  transform(value: number = 0, currency: string = 'RUR'): any {
    value = Number(value);
    // Проверяем целое число или нет
    let formattedVal = (value ^ 0) === value ? value : value.toFixed(2);
    formattedVal = String(formattedVal).replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1 ');
    return `${formattedVal} ${symbols[currency]}`;
  }

}



// WEBPACK FOOTER //
// /srv/projects/jsapp/src/app/shared/currency-format.pipe.ts